/**
 * @generated SignedSource<<0cde08d239abb7e6fa3bdc3169a233d6>>
 * @relayHash 74cea7861d3deecdd672e43c4b88d11e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2312b735aa3c534a08b5277cb3b3537aeba7adf4bb55c12e9eefc67f83c12a72

import type { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type IssueRealtimeUpdatesOld_issueDeletedSubscription$variables = {
  cloudId: string;
  projectIds?: ReadonlyArray<string> | null | undefined;
};
export type IssueRealtimeUpdatesOld_issueDeletedSubscription$data = {
  readonly jira: {
    readonly onIssueDeletedByProjectsNoEnrichment: {
      readonly resource: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type IssueRealtimeUpdatesOld_issueDeletedSubscription = {
  response: IssueRealtimeUpdatesOld_issueDeletedSubscription$data;
  variables: IssueRealtimeUpdatesOld_issueDeletedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectIds"
  }
],
v1 = [
  {
    "concreteType": "JiraSubscription",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "projectIds",
            "variableName": "projectIds"
          }
        ],
        "concreteType": "JiraIssueDeletedStreamHubPayload",
        "kind": "LinkedField",
        "name": "onIssueDeletedByProjectsNoEnrichment",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "resource"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "IssueRealtimeUpdatesOld_issueDeletedSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IssueRealtimeUpdatesOld_issueDeletedSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "2312b735aa3c534a08b5277cb3b3537aeba7adf4bb55c12e9eefc67f83c12a72",
    "metadata": {},
    "name": "IssueRealtimeUpdatesOld_issueDeletedSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "c0907310f347cd999732690f33d13e85";

export default node;
